import { vModelDynamic as _vModelDynamic, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bd75226"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "FgElementWrapper" }
const _hoisted_2 = ["type", "autocomplete"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PasswordInputValidation = _resolveComponent("PasswordInputValidation")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([{ 'is-Not-Valid': _ctx.showPasswordError }, "PasswordInputWrapper"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("input", {
        onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.savePassword && _ctx.savePassword(...args))),
        onFocus: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setFocused(true))),
        onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setFocused(false))),
        class: _normalizeClass(["PasswordInput FgInput js-Input", { HasFocus: _ctx.hasFocus, HasValue: _ctx.inputText }]),
        "data-cy": "PasswordInput",
        "aria-label": "Password",
        name: "Password",
        type: _ctx.fieldType,
        ref: "input",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.inputText) = $event)),
        maxlength: "256",
        autocomplete: _ctx.autocompletePasswordType
      }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_2), [
        [_vModelDynamic, _ctx.inputText]
      ]),
      _createElementVNode("label", {
        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.setFocusOnInput && _ctx.setFocusOnInput(...args))),
        class: "FgLabel Label",
        for: "passwordInput"
      }, _toDisplayString(_ctx.inputLabel), 1 /* TEXT */),
      _createElementVNode("button", {
        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.togglePassword && _ctx.togglePassword(...args))),
        class: "TogglePassword",
        type: "button",
        tabindex: "-1"
      }, _toDisplayString(_ctx.toggleText), 1 /* TEXT */)
    ]),
    (_ctx.validation)
      ? (_openBlock(), _createBlock(_component_PasswordInputValidation, { key: 0 }))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}